import React, { useMemo, useState } from 'react';
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Tooltip,
    Stack,
} from '@mui/material';
import ReactTablePdfDownload from 'src/shared/components/table/components/ReactTablePdfDownload';
import ReactTableXLSXDownload from 'src/shared/components/table/components/ReactTableXLSXDownload';

const RiderDutyReport = ({ isReport, page, rowsPerPage, totalElements, onPageChange, onRowsPerPageChange, exportReport }) => {
    const columns = isReport && isReport.length > 0 ? Object.keys(isReport[0]) : [];
    const excludedColumns = ['absenceReason', 'extendApproved', 'customerId', 'hubId', 'roasterId'];

    const formatColumnName = (name) => {
        return name
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase());
    };

    const replaceColons = (column, value) => {
        const columnsToReplace = ['shiftName', 'riderName', 'hubName']; // Adjust as necessary
        if (columnsToReplace.includes(column) && typeof value === 'string') {
            return value.replace(/:/g, ' ');
        }
        return value;
    };

    const handleChangePage = (event, newPage) => {
        onPageChange(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        onRowsPerPageChange(parseInt(event.target.value, 10));
    };

    const filteredReportForExport = useMemo(() => {
        const dataToExport = exportReport && exportReport.length > 0 ? exportReport : isReport;
        return dataToExport.map(row => {
            return Object.keys(row)
                .filter(column => !excludedColumns.includes(column))
                .reduce((obj, key) => {
                    obj[key] = row[key];
                    return obj;
                }, {});
        });
    }, [isReport, exportReport]);

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom className="fw-bold text-success mb-3">
                PICK N DROP RIDER DUTY REPORT
            </Typography>
            <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mb: 2 }}>
                <ReactTableXLSXDownload
                    csvData={filteredReportForExport}
                    fileName="Rider_Duty_Report"
                    title="PICK N DROP RIDER DUTY REPORT"
                />
                <ReactTablePdfDownload
                    csvData={filteredReportForExport}
                    fileName="Rider_Duty_Report"
                    title="PICK N DROP RIDER DUTY REPORT"
                    orientation="landscape"
                />
            </Stack>
            <TableContainer component={Paper} sx={{ maxHeight: '600px', overflowY: 'auto', border: '1px solid #eee' }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell
                                sx={{
                                    backgroundColor: 'rgb(50 202 115)',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    width: '60px'
                                }}
                            >
                                S.No
                            </TableCell>
                            {columns
                                .filter((column) => !excludedColumns.includes(column))
                                .map((column) => (
                                    <TableCell
                                        key={column}
                                        sx={{
                                            backgroundColor: 'rgb(50 202 115)',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {formatColumnName(column)}
                                    </TableCell>
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {isReport.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ backgroundColor: index % 2 === 0 ? 'transparent' : '#f9f9f9' }}
                            >
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    {(page * rowsPerPage) + index + 1}
                                </TableCell>
                                {columns
                                    .filter((column) => !excludedColumns.includes(column))
                                    .map((column) => {
                                        const cellValue = row[column];
                                        const displayValue = (cellValue == ':') ? '' : replaceColons(column, cellValue);

                                        return (
                                            <TableCell
                                                key={column}
                                                sx={{
                                                    whiteSpace: 'nowrap',
                                                    fontSize: '0.82rem'
                                                }}
                                            >
                                                <Tooltip title={String(cellValue || "")} arrow>
                                                    <span>{String(displayValue || "")}</span>
                                                </Tooltip>
                                            </TableCell>
                                        );
                                    })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50, 100]}
                component="div"
                count={totalElements}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Box>
    );
};

export default RiderDutyReport;
